import {
  AccountAvatar,
  type AccountInfo,
  Avatar,
  Flex,
  Popover,
  Space,
  Text,
} from '@/components';
import type { ComponentProps, FC } from 'react';

type Props = {
  accountInfoList: Array<ComponentProps<typeof AccountInfo>>;
};

export const AccountGroup: FC<Props> = ({ accountInfoList }) => {
  return (
    <Avatar.Group
      max={{
        count: 5,
        style: {
          backgroundColor: '#bfbfbf',
        },
      }}
    >
      {accountInfoList.map((attr, idx) => (
        <Popover
          // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
          key={idx}
          placement="bottomLeft"
          content={
            <Space>
              <AccountAvatar iconUrl={attr.iconUrl} />
              <Flex vertical>
                <Text
                  variant="small"
                  color="secondary"
                  text={attr.organizationName}
                />
                <Text variant="footnote" text={attr.accountName} />
              </Flex>
            </Space>
          }
        >
          <span>
            <AccountAvatar iconUrl={attr.iconUrl} />
          </span>
        </Popover>
      ))}
    </Avatar.Group>
  );
};
